import React from 'react';
import { Modal } from '../Modal';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Box, Button, SvgIcon } from '@mui/material';

interface UnsavedFormChangesModalProps {
	open: boolean;
	onSave: () => Promise<void>;
	onSaveAndContinue: () => Promise<void>;
	onContinueWithoutSaving: () => void;
	onCancel: () => void;
	isSaving?: boolean;
}

export const UnsavedFormChangesModal = ({
	open,
	onSave,
	onSaveAndContinue,
	onContinueWithoutSaving,
	onCancel,
	isSaving = false,
}: UnsavedFormChangesModalProps) => {
	return (
		<Modal
			open={open}
			onClose={onCancel}
			modalBody={
				<Stack direction="column" alignItems="center">
					<SvgIcon sx={{ mb: 3, fontSize: 48 }}>
						<svg width="34" height="37" viewBox="0 0 34 37" fill="none">
							<path
								d="M17 0C26.5 0 34 7.5 34 17C34 26.5 26.5 34 17 34C7.5 34 0 26.5 0 17C0 7.5 7.5 0 17 0ZM17 6C15.8954 6 15 6.89543 15 8V18C15 19.1046 15.8954 20 17 20C18.1046 20 19 19.1046 19 18V8C19 6.89543 18.1046 6 17 6ZM17 24C18.1046 24 19 24.8954 19 26C19 27.1046 18.1046 28 17 28C15.8954 28 15 27.1046 15 26C15 24.8954 15.8954 24 17 24Z"
								fill="#ED6C02"
							/>
						</svg>
					</SvgIcon>
					<Typography variant="h2" fontWeight="bold" sx={{ mb: 1 }}>
						Unsaved Changes
					</Typography>
					<Box sx={{ width: '90%', textAlign: 'center', mb: 2 }}>
						<Typography variant="sm" color="text.secondary" align="center">
							You have not saved your changes. Would you like to save?
						</Typography>
					</Box>
				</Stack>
			}
			modalFooter={
				<Stack direction="row" spacing={2} justifyContent="center" width="100%">
					<Button
						variant="outlined"
						color="secondary"
						onClick={onContinueWithoutSaving}
						disabled={isSaving}
					>
						Continue without Saving
					</Button>
					<Button
						variant="outlined"
						color="secondary"
						onClick={onSave}
						disabled={isSaving}
					>
						{isSaving ? 'Saving...' : 'Save'}
					</Button>
					<Button
						variant="contained"
						color="success"
						onClick={onSaveAndContinue}
						disabled={isSaving}
					>
						{isSaving ? 'Saving...' : 'Save and Continue'}
					</Button>
				</Stack>
			}
		/>
	);
};
